import { render } from "./Error.component.vue?vue&type=template&id=d9fce218"
import script from "./Error.component.vue?vue&type=script&lang=js"
export * from "./Error.component.vue?vue&type=script&lang=js"

import "./Error.component.vue?vue&type=style&index=0&id=d9fce218&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
